import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { Select } from "antd";
import { searchClients } from "../../redux/actions";
import { clientLabel } from "./format";

const escapeRegex = (value) => String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export default function ClientSelect({ value, onChange, style, disabled, extra = [], getPopupContainer }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const requestId = useRef(0);
  const timer = useRef(null);

  const load = (text) => {
    const id = ++requestId.current;
    const query = (text || "").trim();
    const pattern = query ? { $regex: escapeRegex(query), $options: "i" } : null;
    const filters = pattern ? {
      $or: [
        { _ref: pattern },
        { firstName: pattern },
        { lastName: pattern },
        { companyName: pattern },
      ],
    } : {};
    dispatch(searchClients(1, 20, filters)).then(({ payload }) => {
      if (id !== requestId.current) return;
      setOptions((payload && payload.data) || []);
    });
  };

  useEffect(() => {
    load("");
    return () => clearTimeout(timer.current);
  }, []);

  const onSearch = (text) => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => load(text), 300);
  };

  const merged = extra.concat(options.filter((item) => !extra.some((kept) => kept._id === item._id)));

  return (
    <Select
      allowClear={!disabled}
      showSearch
      disabled={disabled}
      filterOption={false}
      placeholder={intl.formatMessage({ id: "client" })}
      value={value}
      style={style}
      getPopupContainer={getPopupContainer}
      onSearch={onSearch}
      onChange={onChange}
    >
      {merged.map((client) => (
        <Select.Option key={client._id} value={client._id}>{clientLabel(client)}</Select.Option>
      ))}
    </Select>
  );
}
